export const COUPON_RESET_PERIOD = [
    'immediate',
    'day',
    'week',
    'month',
    'year',
];
export const COUPON_TYPES = [
    'ticket-percent',
    'ticket-fixed',
    'item-percent',
    'item-fixed',
    'free-delivery',
];
export const COUPON_CHANNELS = ['app', 'website', 'pos', 'kiosk'];
export const COUPON_FIRST_TIME_ONLY_SCOPES = [
    'brand',
    'location',
    'channel',
];
export const COUPON_ORDER_TYPES = ['pickup', 'delivery'];
export const MENU_TYPES = ['olo', 'catering'];
export const MENU_FULFILLMENT_TYPES = ['pickup', 'delivery'];
export const MENU_CHANNELS = ['pos', 'online', 'marketplace', 'kiosk'];
export const MENU_SOURCES = [
    'auto-import',
    'manual-owner-import',
    'woflow',
    'json-import',
    'scout',
];
export const MODIFIER_SET_DISPLAY_TYPES = [
    'custom',
    'single-select',
    'multi-select',
    'quantity-select',
    'pizza-topping',
];
export const MENU_ENTITY_COLLECTIONS = [
    'Category',
    'Coupon',
    'Item',
    'Menu',
    'Modifier',
    'ModifierSet',
];
export const ALLERGENS = [
    'dairy',
    'eggs',
    'fish',
    'gluten',
    'mango',
    'peanuts',
    'sesame',
    'shellfish',
    'soy',
    'tree-nuts',
];
export const ITEM_POINT_TRANCHES = [
    250, 500, 1000, 1500, 2000, 2500, 3000, 4000, 5000, 7500, 10000,
];
export const MIN_ITEM_POINTS = 250;
export const ITEM_POINTS_INCREMENT = 50;
export const isValidItemPoints = (points) => Number.isInteger(points) &&
    points >= MIN_ITEM_POINTS &&
    points % ITEM_POINTS_INCREMENT === 0;
export const ENTITY_NAMES = {
    menu: 'menu',
    category: 'category',
    item: 'item',
    modifierSet: 'option group',
    modifier: 'option',
};
//# sourceMappingURL=constants.js.map